import React from 'react';
import './Products.css';

function Products() {
  const products = [
    {
      id: 1,
      category: 'Jupes',
      items: [
        { name: 'Jupe midi fleurie', description: 'Jupe midi à motifs floraux, taille haute' },
        { name: 'Jupe longue bohème', description: 'Jupe longue fluide avec imprimés champêtres' },
        { name: 'Jupe courte printanière', description: 'Jupe courte avec fleurs délicates' }
      ]
    },
    {
      id: 2,
      category: 'Robes',
      items: [
        { name: 'Robe d\'été fleurie', description: 'Robe légère parfaite pour l\'été' },
        { name: 'Robe midi romantique', description: 'Robe midi aux motifs floraux vintage' },
        { name: 'Robe longue champêtre', description: 'Robe longue bohème avec imprimés naturels' }
      ]
    },
    {
      id: 3,
      category: 'Hauts',
      items: [
        { name: 'Blouse fleurie', description: 'Blouse légère aux imprimés délicats' },
        { name: 'Top cache-cœur', description: 'Top cache-cœur avec motifs floraux' },
        { name: 'Chemisier vintage', description: 'Chemisier rétro aux fleurs romantiques' }
      ]
    }
  ];

  return (
    <div className="products">
      <div className="container">
        <h2 className="page-title">Nos Produits</h2>
        <p className="page-subtitle">
          Découvrez nos créations uniques, faites à la main à partir de tissus upcyclés
        </p>

        <div className="products-container">
          {products.map((category) => (
            <section key={category.id} className="product-category">
              <h3 className="category-title">{category.category}</h3>
              <div className="product-grid">
                {category.items.map((item, index) => (
                  <div key={index} className="product-card">
                    <div className={`product-image product-image-${category.id}-${index + 1}`}>
                      <span className="product-emoji">
                        {category.category === 'Jupes' ? '👗' : 
                         category.category === 'Robes' ? '👚' : '👕'}
                      </span>
                    </div>
                    <div className="product-info">
                      <h4 className="product-name">{item.name}</h4>
                      <p className="product-description">{item.description}</p>
                      <span className="product-badge">Pièce unique</span>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="info-banner">
          <p>
            ✨ Chaque pièce est unique et peut varier selon les tissus disponibles. 
            N'hésitez pas à nous contacter pour connaître les créations disponibles actuellement !
          </p>
        </div>
      </div>
    </div>
  );
}

export default Products;
